"use client";
import React from 'react';

const ThemeContext = React.createContext({});

export { ThemeContext };
//# sourceMappingURL=Context.js.map
